import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import PedidoDetalle from './PedidoDetalle';
import getFechasHistorial from '../../../utils/getFechasHistorial'
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap_white.css';

const TablaFechashtml = props => (
  <div>
    <table className={'table table-hover'}>
      <thead className='table-head'>
        <tr>
          <th rowSpan='2'>
            <div className='checkbox checkbox-inline' >
            <label>
              <input type='checkbox' id={'checkBoxAll'} onClick={() => props.selectAll()} />
              <div className='checkbox-skin' />
            </label>
            </div>
          </th>
          <th rowSpan='2' class='text-center'>Nº Pedido</th>
          <th rowSpan='2' class='text-center'>Nº Chasis</th>
          <th rowSpan='2' class='text-center'>Estado</th>
          <th colSpan='2' class='text-center'>F° Carroceros</th>
          <th colSpan='2' class='text-center'>F° Logística</th>
          <th colSpan='2' class='text-center'>F° Comercial</th>
        </tr>
        <tr>
          <th style={{ textTransform: 'capitalize', paddingLeft: '1rem' }}>Compromiso</th>
          <th style={{ textTransform: 'capitalize', paddingLeft: '1rem' }}>Entrega</th>
          <th style={{ textTransform: 'capitalize', paddingLeft: '1rem' }}>Compromiso</th>
          <th style={{ textTransform: 'capitalize', paddingLeft: '1rem' }}>Entrega</th>
          <th style={{ textTransform: 'capitalize', paddingLeft: '1rem' }}>Compromiso</th>
          <th style={{ textTransform: 'capitalize', paddingLeft: '1rem' }}>Entrega</th>
        </tr>
      </thead>
      <tbody>
        {
          props.pedidos.length>0?(
          props.pedidos.map(data =>
            <tr key={data.numPedidoVeh}>
              <td>
                <div className='checkbox checkbox-inline'>
                  <label htmlFor={`${data.numPedidoVeh}-fechas`}>
                    <input
                      type='checkbox'
                      checked={props.pedidosConCheck.indexOf(data.numPedidoVeh)>=0}
                      onChange={() => props.selectCheckPedidos(data.numPedidoVeh,data.nurFichaVtaPedido)}
                      id={`${data.numPedidoVeh}-fechas`}
                    />
                    <div className='checkbox-skin' />
                  </label>
                </div>
              </td>
              <td><button className='btn btn-iconLeft btn-link' data-dismiss='modal' data-toggle='modal' data-target='#fdv-detalle'  onClick={() => props.fnSelectPedido(data.numPedidoVeh)} ><i/><span>{data.numPedidoVeh}</span></button></td>
              <td>{data.numChasis}</td>
              <td><span className='pill pill-block pill-yellow'>{data.estadoPedido}</span></td>
              <td >
              {!data.fck ? ('-') :(
                data.his2>0?(
                <Tooltip
                animation='zoom'
                overlay={
                  <div style={{ textAlign: 'center' }} ><span style={{ fontWeight: 'bold' }}>Fechas Carroceros </span><br />
                    <ul style={{ listStyle: 'none', padding: '0', margin: '0' , textAlign: 'left'}} >
                          {
                            props.dataTooltip !== undefined &&
                            props.dataTooltip.map((entity,index)=>
                            <li style={{ fontSize: '0.9em' }} key={index}>
                                {
                                 moment(entity.fechaCompromiso).format('DD/MM/YYYY') + ' - ' +  entity.desMotivo  + ' - ' +  entity.tipoFechaCompromiso
                                }
                            </li>
                          )
                          }
                    </ul>
                  </div>
                }
                ref={(tooltip) => { this.tooltip = tooltip; }}
                >
                  <a href='#' style={{color:'#4b5665'}}  onMouseEnter={(e)=>props.onEnterTooltip(data,'FCK','FRK')}   onMouseLeave ={(e)=> props.onLeaveTooltip(data)} >
                  <i className="ion-record c-yellow mr-2" ></i>
                  {!data.fck ? '-' : moment(data.fck).format('DD/MM/YYYY')}
                  </a>
              </Tooltip> ):(
                <span>
                {!data.fck ? '-' : moment(data.fck).format('DD/MM/YYYY')}
                </span>
              )
              )}
              </td>
              <td>
                {!data.frk ? ('-') :(
                  <span>
                      {data.est1 === 'S'?(<i className="ion-alert-circled c-red mr-2"></i>):(null)}
                      { moment(data.frk).format('DD/MM/YYYY')}
                  </span>
                )}
              </td>

              <td>
                {!data.fcl ? ('-') :(
                  data.his3>0?(
                <Tooltip
                  animation='zoom'
                  overlay={

                    <div style={{ textAlign: 'center' }} ><span style={{ fontWeight: 'bold' }}>Fechas logística</span><br />
                      <ul style={{ listStyle: 'none', padding: '0', margin: '0' , textAlign: 'left'}} >
                            {
                              props.dataTooltip !== undefined &&
                              props.dataTooltip.map((entity,index)=>
                              <li style={{ fontSize: '0.9em' }} key={index}>
                                  {
                                  moment(entity.fechaCompromiso).format('DD/MM/YYYY') + ' - ' +  entity.desMotivo   + ' - ' +  entity.tipoFechaCompromiso

                                  }
                              </li>
                            )
                            }
                      </ul>
                    </div>

                  }
                  ref={(tooltip) => { this.tooltip = tooltip; }}
                  >
                    <a href='#' style={{color:'#4b5665'}}  onMouseEnter={(e)=>props.onEnterTooltip(data,'FCL','FRL')}   onMouseLeave ={(e)=> props.onLeaveTooltip(data)} >
                    <i className="ion-record c-yellow mr-2" ></i>
                    {!data.fcl ? '-' : moment(data.fcl).format('DD/MM/YYYY')}
                    </a>
                </Tooltip>):(
                  <span>
                        {!data.fcl ? '-' : moment(data.fcl).format('DD/MM/YYYY')}
                  </span>
                )
              )}
              </td>
              <td>
              {!data.frl ? ('-'):(
                <span>
                      {data.est2 === 'S'?(<i className="ion-alert-circled c-red mr-2"></i>):(null)}
                  {moment(data.frl).format('DD/MM/YYYY')}
                </span>
              )}
              </td>
              <td>
              {!data.fcc ? ('-'):(
                data.his1>0?(
                <Tooltip
                    animation='zoom'
                    overlay={
                      <div style={{ textAlign: 'center' }} ><span style={{ fontWeight: 'bold' }}>Fechas comercial </span><br />
                        <ul style={{ listStyle: 'none', padding: '0', margin: '0' , textAlign: 'left'}} >
                              {
                                props.dataTooltip !== undefined &&
                                props.dataTooltip.map((entity,index)=>
                                <li style={{ fontSize: '0.9em' }} key={index}>
                                    {
                                    moment(entity.fechaCompromiso).format('DD/MM/YYYY') + ' - ' +  entity.desMotivo + ' - ' +  entity.tipoFechaCompromiso
                                    }
                                </li>
                              )
                              }
                        </ul>
                      </div>
                    }
                    ref={(tooltip) => { this.tooltip = tooltip; }}
                    >
                      <a href='#' style={{color:'#4b5665'}}  onMouseEnter={(e)=>props.onEnterTooltip(data,'FCC','FRC')}   onMouseLeave ={(e)=> props.onLeaveTooltip(data)} >
                      <i className="ion-record c-yellow mr-2" ></i>
                      {!data.fcc ? '-' : moment(data.fcc).format('DD/MM/YYYY')}
                      </a>
                  </Tooltip>):(
                    <span>
                        {!data.fcc ? '-' : moment(data.fcc).format('DD/MM/YYYY')}
                    </span>
                  )
                  )}

              </td>
              <td>
              {!data.frc ? ('-') :(
                <span>
                {data.est3 === 'S'?(<i className="ion-alert-circled c-red mr-2"></i>):(null)}
                { moment(data.frc).format('DD/MM/YYYY')}
                </span>
              )}
              </td>
            </tr>
          )):(
            <tr key='0'>
                <td colSpan='10'><p style={{'text-align':'center'}}> No existe registros !!</p> </td>
            </tr>
          )
        }
      </tbody>
    </table>
    <br />
    <div className="wrapper row mt-3">
        <p className="pull-right"><span className="subInfo mr-2"><i className="ion-record c-yellow mr-2"></i>Contiene fechas anteriores</span><span className="subInfo"><i className="ion-alert-circled c-red mr-2"></i>Fecha a la espera de aprobación</span></p>
    </div>





  </div>
);


class TablaFechas extends Component {

  constructor(props){
    super(props);

    this.state ={
      dataTooltip : [],
      isOpen:false,
     }
  }

  onEnterTooltip = (pedido,tipouno,tipodos) =>{
    this.setState({dataTooltip:[]});
    // idFichaVenta = '', idnurAutFichaVtaVeh = '',cod_cia,cod_prov = '',num_pedido_veh = '',tipoFechaUno = '',tipoFechaDos = ''
    getFechasHistorial(this.props.fdvID,pedido.nurFichaVtaPedido,'','',pedido.numPedidoVeh,tipouno,tipodos).then((resultado)=>{
      if(resultado.data.estadoTrama === '1'){
        this.setState({dataTooltip : resultado.data.listaHisFechCompromiso});
      }
    });


  }

  onLeaveTooltip = (pedido) =>{
    //document.getElementById(pedido.numPedidoVeh+fechaLabel).classList.remove('check-tooltipohover');
    this.setState({dataTooltip:[]});
  }

  closeModal = () =>{
    this.setState({isOpen:false});
  }

  openModal = () =>{
    this.setState({isOpen:true});
  }

  fnSelectPedido = (selectPedido) => {
    this.setState({selectPedido:selectPedido,isOpen:true})

  }


  render(){
    return(
      <div>
          <TablaFechashtml
              pedidos={this.props.pedidos}
              numProfVeh={this.props.numProforma}
              selectCheckPedidos={this.props.selectCheckPedidos}
              pedidosConCheck={this.props.pedidosConCheck}
              selectAll={this.props.selectAll}
              onEnterTooltip={this.onEnterTooltip}
              onLeaveTooltip ={this.onLeaveTooltip}
              dataTooltip={this.state.dataTooltip}
              fnSelectPedido = {this.fnSelectPedido}
          />

          {
            this.state.isOpen === true &&
            <PedidoDetalle
                isOpen={this.state.isOpen}
                closeModal = {this.closeModal}
                pedidos={this.props.pedidos.length > 0? this.props.pedidos.filter(entry => entry.numPedidoVeh===this.state.selectPedido)[0] : {}}
            />
          }
      </div>

    )
  }

}



export default TablaFechas;



// WEBPACK FOOTER //
// ./src/pages/DetalleFichaVenta/DetallePedido/TablaFechas.js